import React, { useEffect } from "react"
import { useFetch } from "hooks/use-new-fetch"
import { Text } from "@convertkit/slate"
import { useEditor } from "../../editor-context"
import Spotify from "./spotify"

const getSpotifyId = link =>
  link
    .split("/")
    .pop()
    .split("?")[0]

const getSpotifyType = link => link.split("/")[3]

function SpotifyNode({ node, attributes, data }) {
  const editor = useEditor()
  const id = data.spotifyId
  const type = data.spotifyType
  const [request] = useFetch(`/spotify/${id}:${type}`)

  useEffect(() => {
    if (!editor) return
    if (data.spotify) return
    request.get().then(({ data: response }) => {
      if (response.error) {
        editor.removeNodeByKey(node.key)
        editor.insertLink({ href: data.href })
        return
      }
      editor.setNodeByKey(node.key, {
        data: { ...data, spotify: response }
      })
    })
  }, [editor])

  const spotify = data.spotify

  if (!spotify) return <div {...attributes} />

  return <Spotify data={data} attributes={attributes} node={node} />
}

export default {
  component: SpotifyNode,
  email: Spotify,
  schema: {
    isVoid: true
  },
  commands: {
    insertSpotify: (editor, { href, ...attributes }) => {
      const spotifyId = getSpotifyId(href)
      const spotifyType = getSpotifyType(href)
      editor.insertBlock({
        type: "spotify",
        data: { href, spotifyId, spotifyType, ...attributes },
        nodes: [Text.create("")]
      })
    }
  }
}
